export default {"src":"/_next/static/media/filter-icon-black.2d6a379c.svg","height":18,"width":22,"blurWidth":0,"blurHeight":0};